import React from 'react'
import { WemoloTypography } from '../../../components/Wemolo'
import styles from './lotUtils.module.css'

export const getOccupancyDisplayUI = (value?: string, color: boolean | string = true, override = false) => {
    if (!value) {
        return null
    }

    let colorValue: string
    let opacity = 1

    if (typeof color === 'string') {
        colorValue = color.startsWith('#') ? color : `#${color}`
    } else {
        colorValue = color ? '#00ff00' : '#ff0000'
    }
    if (override) opacity = 0.3
    return (
        <div className={styles.occupancyOuter} style={{ opacity }}>
            <div className={styles.occupancyInner} style={{ color: colorValue }}>
                <WemoloTypography variant="headline-small" tag="span">
                    {value}
                </WemoloTypography>
            </div>
        </div>
    )
}
